'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Option": "Polaris-Listbox-Option",
  "divider": "Polaris-Listbox-Option--divider"
};

exports.default = styles;
